'use client';
import { Header } from '@/ui-components/organisms/Header/Header';
import { Grid } from '@/ui-components/atoms/Layout/Grid/Grid';
import { Text } from '@/ui-components/atoms/Text/Text';
import { StyledContainer } from '@/ui-components/atoms/Layout/StyledContainer/StyledContainer';
import { RenderRTE } from '@/components-2.0/structure/RenderRTE';
import { FlexibleFormVariant } from './FlexibleFormBase';
import styles from './flexibleForm.module.scss';

const { leftAlignedHeaderStyles, submitButtonWrapperCentered, duplicationFormErrorCentered, ctaCaption } = styles;

export interface FlexibleFormVariantFactoryArgs {
    asset: SiteFlexibleForm;
    nestedForm: boolean;
    toggleForm: boolean;
    hasHeadlineContent: boolean;
    isCenter: boolean;
}

interface CenteredFlexibleFormContentArgs extends FlexibleFormVariantFactoryArgs {
    formClassName: string;
}

type FlexibleFormContentArgs = Parameters<FlexibleFormVariant['renderContent']>[0];

export function renderCenteredFlexibleFormContent(
    { asset, nestedForm, toggleForm, hasHeadlineContent, formClassName }: CenteredFlexibleFormContentArgs,
    { wrappedFieldElements, duplicateError, duplicateErrorMessage, submitButton, errorDisplay }: FlexibleFormContentArgs,
) {
    const { headline, description, cta_caption } = asset.fields;

    return (
        <>
            {hasHeadlineContent && !toggleForm && (
                <StyledContainer standardMoleculeSpacing>
                    <Header
                        headingTag="h2"
                        heading={<RenderRTE contentfulDoc={headline} />}
                        subhead={<RenderRTE contentfulDoc={description} />}
                    />
                </StyledContainer>
            )}
            <Grid container noPadding={nestedForm}>
                <Grid
                    col={nestedForm ? { sm: 12 } : { sm: 12, md: 6, lg: 6 }}
                    start={nestedForm ? { sm: 1 } : { md: 4, lg: 4 }}
                >
                    {errorDisplay}
                </Grid>
                <Grid
                    col={nestedForm ? { sm: 12 } : { sm: 12, md: 6, lg: 6 }}
                    start={nestedForm ? { sm: 1 } : { md: 4, lg: 4 }}
                >
                    <div>
                        <div className={formClassName}>{wrappedFieldElements}</div>
                        <div className={submitButtonWrapperCentered}>
                            {duplicateError && (
                                <StyledContainer>
                                    <Text tag="div" className={duplicationFormErrorCentered} role="alert">
                                        {duplicateErrorMessage}
                                    </Text>
                                </StyledContainer>
                            )}
                            {submitButton}
                            {cta_caption && <RenderRTE contentfulDoc={cta_caption} className={ctaCaption} />}
                        </div>
                    </div>
                </Grid>
            </Grid>
        </>
    );
}

export { leftAlignedHeaderStyles };
